import axios from "../axios_config";

export function postPushToken(token) {
	return axios.post("/v1/user-fcm/web-push-token", { token });
}

export function deletePushToken(token) {
	return axios.delete("/v1/user-fcm/web-push-token", { data: { token } });
}
